class ElephantFloating extends HTMLElement {
  constructor() {
    super();
    this.use_circle = JSON.parse(this.querySelector('span.use_circle')?.innerHTML ?? false);
    this.elephantSvg = this.querySelector('svg');
    this.elephantWrapper = this.querySelector('.elephant-sticky-wrapper');
    this.filterCircle = this.querySelector('.elephant-circle-filter');
    this.filterCircleCloseBtn = this.querySelector('.elephant-circle-filter .close-elephant-circle-filter');
    this.elephantOverlay = this.querySelector('.elephant-overlay');

    this.elephantSvg.addEventListener('click', this.openFilter.bind(this))
    this.filterCircleCloseBtn.addEventListener('click', this.closeFilter.bind(this));
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeFilter.bind(this));
    this.elephantOverlay.addEventListener('click', this.closeFilter.bind(this));
  }
  openFilter() {
    this.filterCircle.style.display = 'block';
    setTimeout(() => {
      this.elephantWrapper.classList.add('visible-filter');
      this.elephantOverlay.classList.add('overlay-active');
    }, 0)
  }
  closeFilter() {
    this.elephantWrapper.classList.remove('visible-filter');
    this.elephantOverlay.classList.remove('overlay-active');
    setTimeout(() => {
      this.filterCircle.style.display = 'none';
    }, 450)
  }
}

customElements.define('elephant-floating', ElephantFloating);